import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

class Kiosk {
  Positions = async (
    operatorId,
    companyId,
    subCompanyId,
    siteId,
    online,
    offlineSiteOpen,
    offlineSiteClosed,
    pending,
    authReq,
  ) => {
    const response = await axios.get(
      `Kiosk/Positions2/${operatorId},${companyId},${subCompanyId},${siteId},${online},${offlineSiteOpen},${offlineSiteClosed},${pending},${authReq}`,
    );
    return response.data;
  };

  prepareData = (
    installationId,
    startDate,
    endDate,
    collectionDate,
    useCollectionWeek,
    showEvents,
    details,
    pageNumber,
  ) => {
    const payload = {
      installationId,
      startDate: useCollectionWeek === 0 ? startDate.toISOString(true) : null,
      endDate: useCollectionWeek === 0 ? endDate.toISOString(true) : null,
      collectionDate: useCollectionWeek === 1 ? collectionDate : null,
      useCurrentWeek: useCollectionWeek === 2,
      showEvents,
      pageNumber,
      details: prepareDetails(details),
    };

    return payload;
  };

  Transactions = async (
    installationId,
    startDate,
    endDate,
    collectionDate,
    useCollectionWeek,
    showEvents,
    details,
    pageNumber,
  ) => {
    const payload = this.prepareData(
      installationId,
      startDate,
      endDate,
      collectionDate,
      useCollectionWeek,
      showEvents,
      details,
      pageNumber,
    );
    const transactions = await axios.put(`Kiosk/byInst/filter/`, payload);
    const summary = await axios.put(`Kiosk/byInst/summary/`, payload);

    return { transactions: transactions.data, summary: summary.data };
  };

  Export = async (
    installationId,
    startDate,
    endDate,
    collectionDate,
    useCollectionWeek,
    showEvents,
    details,
    pageNumber,
  ) => {
    const payload = this.prepareData(
      installationId,
      startDate,
      endDate,
      collectionDate,
      useCollectionWeek,
      showEvents,
      details,
      pageNumber,
    );
    return await axios.put(`Kiosk/byInst/export/`, payload, {
      responseType: "arraybuffer",
    });
  };

  Detail = async (installationId, detailId) => {
    const response = await axios.get(
      `Kiosk/Detail/${installationId},${detailId}`,
    );
    return response.data;
  };

  Floats = async (installationId) => {
    const response = await axios.get(`Kiosk/Floats/${installationId}`);
    return response.data;
  };

  UpdateFloats = async (installationId, details) => {
    const response = await axios.put(`Kiosk/Floats/Update`, {
      installationId,
      details: prepareDetails(details),
      complete: true,
    });
    return response.data;
  };
}
const kiosk = new Kiosk();

export default kiosk;
